export const TABS = ['1. EMPIEZA AQUÍ', '2. LISTA DE VIDEOS', '3. MATERIALES DEL PROGRAMA'];

export const Tabs = ({ active, onChange }: { active: string; onChange: (tab: string) => void }) => (
  <div className="flex">
    {TABS.map(tab => (
      <button
        key={tab}
        onClick={() => onChange(tab)}
        className={`flex-1 py-2 text-center border-b-2 cursor-pointer ${active === tab ? 'border-black font-semibold' : 'text-gray-500 border-gray-300'}`}
      >
        <span className="md:inline hidden">{tab}</span>
        <span className="md:hidden inline">
          {tab.includes('EMPIEZA') ? 'EMPIEZA' : tab.includes('VIDEOS') ? 'VIDEOS' : 'MATERIALES'}
        </span>
      </button>
    ))}
  </div>
);
